import api from './api';

export type LeadSource = 'partner' | 'contact';
export type LeadStatus = 'new' | 'contacted' | 'qualified' | 'converted' | 'rejected';

export interface CRMLead {
    id: string;
    source: LeadSource;
    status: LeadStatus;
    name: string;
    email: string;
    phone?: string;
    whatsapp?: string;
    country?: string;
    profile?: string;
    network?: string;
    subject?: string;
    message?: string;
    notes?: string;
    ip: string;
    createdAt: string;
    updatedAt: string;
}

export interface GetLeadsResult {
    leads: CRMLead[];
    total: number;
}

export interface ConvertPartnerPayload {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    companyName: string;
    country?: string;
}

export const crmService = {
    getLeads: (params?: { source?: LeadSource; status?: LeadStatus; page?: number; limit?: number }) =>
        api.get<{ status: string; data: GetLeadsResult }>('/crm/leads', { params }),

    getNewCount: () =>
        api.get<{ status: string; data: { count: number } }>('/crm/leads/count'),

    updateLead: (id: string, data: { status?: LeadStatus; notes?: string }) =>
        api.patch<{ status: string; data: { lead: CRMLead } }>(`/crm/leads/${id}`, data),

    deleteLead: (id: string) =>
        api.delete(`/crm/leads/${id}`),

    convertToPartner: (id: string, payload: ConvertPartnerPayload) =>
        api.post<{ status: string; data: { userId: string; partnerId: string } }>(
            `/crm/leads/${id}/convert`,
            payload,
        ),
};
